import BaseModelInstance from './base.model'
import { UsersUniversitySession as ModelDefinition } from './model-definitions'

class UsersUniversitySession extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default UsersUniversitySession
